import axios from 'axios'
import * as HttpStatus from 'http-status-codes'

export function getRequest(url: string, config = {}) {
  return axios.get(url, config).then((response) => {
    if (response.status === HttpStatus.OK) {
      return response.data
    }
  })
}

export function postRequest(url: string, payload: any = null, config = {}) {
  return axios.post(url, payload, config).then((response) => {
    if (
      response.status === HttpStatus.OK ||
      response.status === HttpStatus.CREATED ||
      response.status === HttpStatus.ACCEPTED
    ) {
      return response.data
    }
  })
}

export function putRequest(url: string, payload: any = null, config = {}) {
  return axios.put(url, payload || null, config).then((response) => {
    if (response.status === HttpStatus.OK) {
      return response.data
    }
  })
}

export function patchRequest(url: string, payload: any = null, config = {}) {
  return axios.patch(url, payload, config).then((response) => {
    if (response.status === HttpStatus.OK) {
      return response.data
    }
  })
}

export function deleteRequest(url: string, config = {}) {
  return axios.delete(url, config).then((response) => {
    if (response.status === HttpStatus.OK) {
      return response.data
    }
  })
}
